/**
 * The drawings this dialog needs and the app's glyph registries do not carry: a phone, a house,
 * the chevrons the month picker pages with, and the confirmation's tick.
 *
 * The dismiss cross is NOT here — it is `shared/ui/FormGlyphs`' `CloseGlyph`, promoted on 22
 * September 2026 when "Nowy program" grew the same one.
 *
 * Transcribed from `docs/design/plan-propozycje-2026-09-21/plan.js`'s icon table. They are
 * `aria-hidden` wherever they are used — each one stands beside a label that already says the word
 * — so none of them carries a title.
 */

export function PhoneGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden="true">
      <rect x="5.5" y="2" width="9" height="16" rx="2" />
      <path d="M8.5 15h3" />
    </svg>
  );
}

export function HomeGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 9.5 10 4l7 5.5V16a1 1 0 0 1-1 1h-4v-5H8v5H4a1 1 0 0 1-1-1z" />
    </svg>
  );
}

export function ChevronLeftGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m15 18-6-6 6-6" />
    </svg>
  );
}

export function ChevronRightGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}

export function TickGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}
